import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=ecd23886&"
import script from "./test1.vue?vue&type=script&lang=js&"
export * from "./test1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecd23886')) {
      api.createRecord('ecd23886', component.options)
    } else {
      api.reload('ecd23886', component.options)
    }
    module.hot.accept("./test1.vue?vue&type=template&id=ecd23886&", function () {
      api.rerender('ecd23886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/dynamicSegment/test1.vue"
export default component.exports